import { identity } from "@fullcalendar/react";
import {
  CREATETODO,
  GETALLDEPARTMENTBYCOMPANYID,
  GETMANAGETODO,
  GETUSERSBYDEPARTMENTID,
  GETVALIDATIONAPIID,
  GET_TODO_CONTROLS,
  GET_ACTIVITY_DATA_WITH_CUSTOMFIELD,
  GET_ALL_ACTIVITY_WITH_CUSTOM_FIELD,
  GET_ACTIVITY_DATA_FOR_ONBOARDING,
  SET_TODO_NOTIFICATION_DATA,
  SET_TODO_DATA_BY_TODO_ID,
  GET_DEFAULT_MASTER_TODOS,
  SET_TODO_FIELD_LIST
} from "../constants";
import { ApiCall } from "../../utils/index";

export const getAllToDO =
  (
    searchQuery,
    filterOptions,
    sortField,
    sortOrder,
    page,
    pageSize,
    cb = null
  ) =>
  async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const searchParam = searchQuery ? `search=${searchQuery}` : "";
      const result = await ApiCall.get(
        `/activity/company?${searchParam}&filter_options=${filterOptions}&sort_field=${sortField}&sort_order=${sortOrder}&page=${page}&page_size=${pageSize}`,
        token
      );

      dispatch({ type: GETMANAGETODO, payload: result.data });
      if (cb) {
        cb(result);
      }
    } catch (err) {
      if (cb) {
        cb(err);
      }
    }
  };

export const getAllDepartmentByCompanyId =
  (cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { company, token },
      } = getState();
      const result = await ApiCall.get(`/department/status/active`, token);
      dispatch({
        type: GETALLDEPARTMENTBYCOMPANYID,
        payload: result.data,
      });
      cb(result);
    } catch (err) {
      cb(err);
    }
  };

export const getUsersByDepartmentId =
  (id, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(`/user/department/${id}`, token);
      dispatch({
        type: GETUSERSBYDEPARTMENTID,
        payload: result.data,
      });
      cb(result);
    } catch (err) {
      cb(err);
    }
  };

export const getValidationApi = () => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.get(`/validationApi/fetchall`, token);
    dispatch({
      type: GETVALIDATIONAPIID,
      payload: result.data,
    });
    //cb(result.data);
  } catch (err) {
    //cb(err?.response?.data);
  }
};

export const createToDo = (payload, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post("/activity/add", payload, token);
    dispatch({
      type: CREATETODO,
      payload: result,
    });
    cb(result);
  } catch (err) {
    cb(err);
  }
};

export const getToDoById = (id, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.get(`/activity/byId/${id}`, token);

    dispatch({
      type: SET_TODO_DATA_BY_TODO_ID,
      payload: result.data
    })

    cb(result);
  } catch (err) {
    console.log("err", err);
    cb(err);
  }
};

export const updateToDo = (payload, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.put(`/activity`, payload, token);
    cb(result);
  } catch (err) {
    cb(err);
  }
};

export const deleteManageTodo = (id, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.delete(`/activity/${id}`, token);
    cb(result);
  } catch (error) {
    cb(error);
  }
};

export const getActivityDataToShowCards =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(`/activity/with/customfields`, token);

      dispatch({
        type: GET_ACTIVITY_DATA_WITH_CUSTOMFIELD,
        payload: result.data,
      });
    } catch (error) {
      request.onError();
    }
  };

export const getAllActivityWithCustomField =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(`/activity/allwith/customfields`, token);

      dispatch({
        type: GET_ALL_ACTIVITY_WITH_CUSTOM_FIELD,
        payload: result.data,
      });
    } catch (error) {
      request.onError();
    }
  };

// Get API for onboarding slider
export const getActivityDataForOnboarding =
  (cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(`/onboarding/activities`, token);
      dispatch({
        type: GET_ACTIVITY_DATA_FOR_ONBOARDING,
        payload: result.data,
      });
    } catch (error) {
      cb(error);
    }
  };

// Post API to create add custom fields in to do
export const createandupdateActivityCustomFields =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.post(
        "/activitycustomfields",
        request.payload,
        token
      );

      request.onSuccess();
    } catch (error) {
      request.onError();
    }
  };

// GET Api to get custome field of to do
export const getToDoControlsByActivityId =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(
        `/activitycustomfields/${request.activity_id}`,
        token
      );

      dispatch({
        type: GET_TODO_CONTROLS,
        payload: result.data,
      });
      request.onSuccess(result.data);
      // request.onSuccess(result);
    } catch (error) {
      request.onError(error);
    }
  };

// PATCH API to update custome field
export const updateActivityCustomField =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.patch(
        `/activitycustomfields`,
        request.payload,
        token
      );
      request.onSuccess();
    } catch (error) {
      request.onError(error);
    }
  };

// POST API to add and update To Do Notification
export const addToDoNotification = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post(
      `/todo_notification`,
      request.payload,
      token
    );
    request.onSuccess();
  } catch (error) {
    request.onError(error);
  }
};

// GET API to get To Do Notification Data
export const getToDoNotificationData =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(`/todo_notification/by_todo/${request.todo_id}`, token)
      dispatch({type: SET_TODO_NOTIFICATION_DATA ,  payload: result.data})
    } catch (error) {
      request.onError(error);
    }
  };

// GET API to get default master To Do
export const getMasterToDosList = (request) => async (dispatch, getState) => {
  try {
    const {auth : {token}} = getState();
    const result = await ApiCall.get('/master/todo/company', token);
    dispatch({type: GET_DEFAULT_MASTER_TODOS, payload: result.data});
    request.onSuccess();
  } catch (error) {
    request.onError(error)
  }
} 

// POST API to import master To Do
export const importMasterToDo = (request) => async(dispatch, getState) => {
  try {
    const {auth: {token}} = getState();
    console.log('payload --', request.payload )
    const result = await ApiCall.post('/activity/import', request.payload, token);
    request.onSuccess();
  } catch (error) {
    request.onError(error)
  }
}


export const getTodoCustomFieldList = (id) => async(dispatch, getState) => {
  try {
    const { auth: {token} } = getState();
    const result = await ApiCall.get(`/activity/custom_field/list/${id}`, token);
    dispatch({type: SET_TODO_FIELD_LIST, payload: result.data })
  } catch (error) {
    console.log(error)
  }
}
